import dynamic from 'next/dynamic';
import React from 'react';

import type { NextPageWithLayout } from 'nextjs/types';

import PageNextJs from 'nextjs/PageNextJs';

const VerifiedContracts = dynamic(() => import('ui/saba/SabaContracts'), { ssr: false });

const Page: NextPageWithLayout = () => {
  return (
    <PageNextJs pathname="/verified-contracts">
      <VerifiedContracts/>
    </PageNextJs>
  );
};

Page.getLayout = function getLayout(page: React.ReactElement) {
  return page;
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps';
